import { Icon } from '@iconify/react'
import React, { useEffect, useState } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import { CoreToggleButtonGroup, CoreToggleButton } from 'src/components/core'
import { getButtonWrapperFromSelection, selectionStore } from '../selection'

const BlockOptionsModal = props => {
  const { classes, editor } = props
  const [alignment, setAlignment] = useState('')
  const [sizing, setSizing] = useState('')

  useEffect(() => {
    if (editor) {
      const storedSelection = selectionStore.getButtonWrapperSelection()

      if (storedSelection) {
        const buttonWrapper = getButtonWrapperFromSelection(storedSelection)
        if (buttonWrapper) {
          const modelElement = editor.editing.mapper.toModelElement(
            buttonWrapper,
          )
          if (modelElement) {
            const currentAlignment = modelElement.getAttribute('dataAlignment')
            if (currentAlignment) {
              setAlignment(currentAlignment)
            }
            const currentSizing = modelElement.getAttribute('dataSizing')
            if (currentSizing) {
              setSizing(currentSizing)
            }
          }
        }
      }
    }
  }, [editor])

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment)
      editor.editing.view.focus()

      const storedSelection = selectionStore.getButtonWrapperSelection()

      if (storedSelection) {
        const buttonWrapper = getButtonWrapperFromSelection(storedSelection)

        if (buttonWrapper) {
          // Perform the change through the model
          editor.model.change(writer => {
            // Find the corresponding model element
            const modelElement = editor.editing.mapper.toModelElement(
              buttonWrapper,
            )
            if (modelElement) {
              // Use setAttribute through the writer
              writer.setAttribute('dataAlignment', newAlignment, modelElement)
            }
          })
        }
      }
    }
  }

  const handleSizing = (event, newSizing) => {
    if (newSizing !== null) {
      setSizing(newSizing)
      editor.editing.view.focus()

      const storedSelection = selectionStore.getButtonWrapperSelection()

      if (storedSelection) {
        const buttonWrapper = getButtonWrapperFromSelection(storedSelection)

        if (buttonWrapper) {
          // Perform the change through the model
          editor.model.change(writer => {
            // Find the corresponding model element
            const modelElement = editor.editing.mapper.toModelElement(
              buttonWrapper,
            )
            if (modelElement) {
              // Use setAttribute through the writer
              writer.setAttribute('dataSizing', newSizing, modelElement)
            }
          })
        }
      }
    }
  }

  return (
    <div className={classes.box}>
      <div className={classes.row}>
        <div>
          <Typography className={classes.header}>Alignment</Typography>
        </div>
        <CoreToggleButtonGroup
          value={alignment}
          onChange={handleAlignment}
          exclusive
          fullWidth
        >
          <CoreToggleButton value="left">
            <Icon className={classes.icon} icon="proicons:text-align-left" />
          </CoreToggleButton>
          <CoreToggleButton value="center">
            <Icon className={classes.icon} icon="proicons:text-align-center" />
          </CoreToggleButton>
          <CoreToggleButton value="right">
            <Icon className={classes.icon} icon="proicons:text-align-right" />
          </CoreToggleButton>
        </CoreToggleButtonGroup>
      </div>
      <div className={classes.row}>
        <div>
          <Typography className={classes.header}>Sizing</Typography>
        </div>
        <CoreToggleButtonGroup
          value={sizing}
          onChange={handleSizing}
          exclusive
          fullWidth
        >
          <CoreToggleButton value="fit">
            <Typography className={classes.header}>Fit</Typography>
          </CoreToggleButton>
          <CoreToggleButton value="full">
            <Typography className={classes.header}>Full</Typography>
          </CoreToggleButton>
        </CoreToggleButtonGroup>
      </div>
    </div>
  )
}

export default withStyles(styles)(BlockOptionsModal)
